// ─────────────────────────────────────────────
// Oike — Contenido (Content Lab): what «publicado» means (pure; tested by scripts/test-content-plan.mjs).
// Decided with Ale on 04-11-2026: opening LinkedIn, copying or exporting a post never marks it published. A post is
// published only when Ale registers it with its link. Earlier records marked «Posted» without a link stay as they are
// and are shown as «marcado como publicado, sin verificar»: their status alone does not prove a publication.
// ─────────────────────────────────────────────
const LINKEDIN_RE = /^https:\/\/([a-z]{2,3}\.)?linkedin\.com\/\S+$/i;
export const isPublicationUrl = (url) => LINKEDIN_RE.test(String(url || '').trim());
/** verified | unverified (earlier «Posted» without a link) | draft | scheduled */
export function publicationOf(fields = {}) {
  const status = String(fields['Status'] || 'Draft');
  if (status === 'Posted') return isPublicationUrl(fields['LinkedIn URL']) ? 'verified' : 'unverified';
  return status === 'Scheduled' ? 'scheduled' : 'draft';
}
export const PUBLICATION_LABEL = { verified: 'Publicado (con enlace)', unverified: 'Marcado como publicado (registro anterior, sin verificar)', draft: 'Borrador', scheduled: 'Programado' };
/** The fields written when Ale registers the publication: only with a valid link. */
export function publicationFields(url, today = new Date().toISOString().slice(0, 10)) {
  if (!isPublicationUrl(url)) return null;
  return { 'Status': 'Posted', 'Posted Date': today, 'LinkedIn URL': String(url).trim() };
}
